import { Box } from "@mui/material";
import React from "react";

// Type definition for card positions
export interface CardPosition {
    left: number;
    top: number;
    width: number;
    height: number;
}

interface BaseSpreadProps {
    positions: CardPosition[];
    size?: number;
    cardWidth: number;
    displaySpread: boolean;
    getCard: (index: number) => React.ReactNode;
    rotatedCards?: number[]; // Array of card indices that should be rotated
    name: string; // Name for the spread (used for key generation)
}

const BaseSpread: React.FC<BaseSpreadProps> = ({
    positions,
    size,
    cardWidth,
    displaySpread,
    getCard,
    rotatedCards = [],
    name
}) => {
    const width = cardWidth;
    const height = width * 1.726;

    return (
        <Box sx={{
            display: displaySpread ? 'block' : 'none',
            position: 'relative',
            width: '100%',
            height: '100%',
            minHeight: '500px',
            padding: "0px",
            margin: '0',
            overflow: 'visible',
        }}>
            {positions.map((position, cardIndex) => (
                <Box
                    key={`${name}-card-${cardIndex}`}
                    sx={{
                        position: 'absolute',
                        left: `${position.left}%`,
                        top: `${position.top}%`,
                        width: `${width}px`,
                        height: `${height}px`,
                        zIndex: rotatedCards.includes(cardIndex) ? 2 : 1,
                        transform: rotatedCards.includes(cardIndex) ? 'rotate(90deg)' : 'none',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'visible',
                    }}
                >
                    {getCard(cardIndex)}
                </Box>
            ))}
        </Box>
    );
};

export default BaseSpread; 